import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Text from "@commons/Typography/Text";
import { usePage } from "@hooks/usePage";
import { useNavigate } from "react-router-dom";

function HeaderBreadcrumb() {
  const { breadcrumb } = usePage();
  const navigate = useNavigate();

  const handleBreadcrumbClick = (event: React.MouseEvent, path?: string) => {
    event.preventDefault();
    if (path) {
      navigate(path);
    }
  };

  return (
    <Breadcrumbs
      aria-label="breadcrumb"
      className="font-sans font-medium hidden sm:inline"
    >
      {breadcrumb.map((item, index) => (
        <Link
          key={`${item.label}-${index}`}
          underline="hover"
          color="inherit"
          href={item.path || "#"}
          onClick={(event) => handleBreadcrumbClick(event, item.path)}
          sx={{ cursor: item.path ? "pointer" : "default" }}
        >
          <Text customVariant="gray" className="capitalize">
            {item.label}
          </Text>
        </Link>
      ))}
    </Breadcrumbs>
  );
}

export default HeaderBreadcrumb;
